import React from "react";
import PropTypes from "prop-types";
import { Feed } from "semantic-ui-react";
import { styles } from "./element";
import Moment from "react-moment";
const CityCustomFeed = ({ cityname, date, data, head, ...props }) => {
  return (
    <Feed style={{ margin: 0 }}>
      <Feed.Event>
        {typeof data === "string" && typeof data != "undefined" ? (
          <Feed.Content>
            <Feed.Summary {...props} style={styles}>
              {head ? (
                <span>
                  {" "}
                  {head}
                  <a
                    style={
                      head === "Reviews :"
                        ? { paddingLeft: 20 }
                        : { paddingLeft: 10 }
                    }
                    href={`/City/${cityname}`}
                    target="_blank"
                    title={cityname}
                  >
                    {data}
                  </a>{" "}
                </span>
              ) : (
                <a
                  style={{ paddingLeft: 83 }}
                  href={`/City/${cityname}`}
                  target="_blank"
                  title={cityname}
                >
                  {data}
                </a>
              )}
              {date ? (
                <Feed style={{ float: "right", margin: "0px" }}>
                  <Moment format="MM/DD/YYYY">{date}</Moment>
                </Feed>
              ) : null}
            </Feed.Summary>
          </Feed.Content>
        ) : (
          <div>
            {typeof data != "undefined" &&
              data &&
              data.map((item, index) => (
                <Feed.Content key={index}>
                  <Feed.Summary {...props} style={styles}>
                    {head ? head : null} <a>{item.data}</a>
                    {date ? (
                      <Feed.Date content={date} style={{ float: "right" }} />
                    ) : null}
                  </Feed.Summary>
                </Feed.Content>
              ))}
          </div>
        )}
      </Feed.Event>
    </Feed>
  );
};

CityCustomFeed.propTypes = {
  date: PropTypes.any,
  data: PropTypes.any,
};
export default CityCustomFeed;
